// @ts-nocheck
import {NgModule} from '@angular/core';
import {NumPadDirective} from './numpad.directive';

@NgModule({
  declarations: [
    NumPadDirective,
  ],
  imports: [],
  exports: [
    NumPadDirective,
  ]
})
export class LsnNumpadModule {
}
